import { render, staticRenderFns } from "./MyTabbar.vue?vue&type=template&id=0b487414&"
import script from "./MyTabbar.vue?vue&type=script&lang=js&"
export * from "./MyTabbar.vue?vue&type=script&lang=js&"
import style0 from "./MyTabbar.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports